import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "page"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_BasePopup = _resolveComponent("BasePopup")!
  const _component_SelectCustomSpendingLimit = _resolveComponent("SelectCustomSpendingLimit")!
  const _component_FullWidthPanel = _resolveComponent("FullWidthPanel")!
  const _component_StepperContent = _resolveComponent("StepperContent")!
  const _component_ConfirmCustomSpendingLimit = _resolveComponent("ConfirmCustomSpendingLimit")!
  const _component_CustomSpendingLimitSuccess = _resolveComponent("CustomSpendingLimitSuccess")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_BasePopup, {
          modelValue: _ctx.isCancelIntegrationPopupOpen,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCancelIntegrationPopupOpen) = $event)),
          "primary-button-action": () => (_ctx.isCancelIntegrationPopupOpen = false),
          "secondary-button-action": _ctx.handleCancelIntegration,
          title: _ctx.t('cancel_integration_alert_title'),
          "primary-button-text": _ctx.t('continue_integration'),
          "secondary-button-text": _ctx.t('cancel_integration'),
          loading: _ctx.deleteIntegrationLoading
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", { innerHTML: _ctx.cancelIntegrationPopupContent }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["modelValue", "primary-button-action", "secondary-button-action", "title", "primary-button-text", "secondary-button-text", "loading"]),
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }),
        _createVNode(_component_Stepper, {
          modelValue: _ctx.activeStep,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeStep) = $event)),
          "max-value": 2,
          "show-logo": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StepperContent, {
              "is-visible": _ctx.activeStep === 1
            }, {
              default: _withCtx(() => [
                (!_ctx.isCustomSpendingLimitSetupFinished)
                  ? (_openBlock(), _createBlock(_component_FullWidthPanel, {
                      key: 0,
                      title: _ctx.t('step_one_title', { store: _ctx.currentStore?.name ?? '' }),
                      description: _ctx.t('step_one_description')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectCustomSpendingLimit, {
                          "selected-store": _ctx.currentStore,
                          "min-limit": _ctx.minLimit,
                          "limit-types": _ctx.spendingLimitTypes,
                          onBack: _ctx.close,
                          onSave: _ctx.nextStep
                        }, null, 8, ["selected-store", "min-limit", "limit-types", "onBack", "onSave"])
                      ]),
                      _: 1
                    }, 8, ["title", "description"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["is-visible"]),
            _createVNode(_component_StepperContent, {
              "is-visible": _ctx.activeStep === 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FullWidthPanel, {
                  class: _normalizeClass({ success: _ctx.isCustomSpendingLimitSetupFinished }),
                  icon: _ctx.isCustomSpendingLimitSetupFinished ? undefined : 'mdi-alert-outline',
                  title: 
            _ctx.isCustomSpendingLimitSetupFinished ? _ctx.t('step_two_success_title') : _ctx.t('step_two_title')
          ,
                  description: 
            _ctx.isCustomSpendingLimitSetupFinished
              ? _ctx.t('step_two_success_description', {
                  amount: _ctx.currentStore.spendingLimit?.activeLimit ?? 0,
                })
              : _ctx.t('step_two_description', { store: _ctx.currentStore?.name ?? '' })
          
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isCustomSpendingLimitSetupFinished)
                      ? (_openBlock(), _createBlock(_component_ConfirmCustomSpendingLimit, {
                          key: 0,
                          "selected-store": _ctx.currentStore,
                          onBack: _ctx.navigateBack,
                          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCancelIntegrationPopupOpen = true))
                        }, null, 8, ["selected-store", "onBack"]))
                      : (_openBlock(), _createBlock(_component_CustomSpendingLimitSuccess, {
                          key: 1,
                          "selected-store": _ctx.currentStore
                        }, null, 8, ["selected-store"]))
                  ]),
                  _: 1
                }, 8, ["class", "icon", "title", "description"])
              ]),
              _: 1
            }, 8, ["is-visible"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
}